// header.js
export function qxStickyHeader() {
    var h = document.querySelector('.qx-header');
    if (!h) return;
    h.classList.toggle('is-stuck', window.scrollY > 80);
}
